import type { PaginationState, SortingState } from '@tanstack/react-table';
import Checkbox from '~/components2/forms/Checkbox';
import type { ExportableColumnDef } from '~/components2/Table';
import type { ParcelDetails } from './store';

export const pagination: PaginationState = {
  pageIndex: 0,
  pageSize: 100,
};

export const sorting: SortingState = [
  {
    id: 'select',
    desc: false,
  },
];

export const columns: ExportableColumnDef<ParcelDetails>[] = [
  {
    id: 'select',
    size: 70,
    enableResizing: false,
    sortIconPosition: 'left',
    exportLabel: 'Parcel Index',
    accessorKey: 'i',
    header: ({ table }) => {
      const isAllChecked = table.getIsAllRowsSelected();

      return (
        <div className="flex h-full w-full items-center justify-end">
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Checkbox
              label=""
              checked={isAllChecked}
              value={isAllChecked}
              data-testid="land-rights-select-all-checkbox"
              onChange={() => {
                table.toggleAllRowsSelected();
              }}
            />
          </div>
        </div>
      );
    },
    cell: (cell) => {
      const isChecked = cell.row.getIsSelected();

      return (
        <div className="flex h-full w-full items-center justify-between">
          <div data-testid={`land-rights-row-index-${cell.row.id}`}>{cell.getValue()}</div>
          <Checkbox
            label=""
            checked={isChecked}
            value={isChecked}
            data-testid={`land-rights-row-checkbox-${cell.row.id}`}
            onChange={(v) => {
              cell.row.toggleSelected(v);
            }}
          />
        </div>
      );
    },
  },
  {
    id: 'parcelId',
    header: 'Parcel ID',
    accessorKey: 'parcelId',
    size: 125,
  },
  {
    id: 'owner',
    header: 'Owner',
    accessorKey: 'owner',
    size: 350,
  },
  {
    id: 'muniName',
    header: 'Municipality Name',
    accessorKey: 'muniName',
  },
  {
    id: 'stateAbbr',
    header: 'State Abbreviation',
    accessorKey: 'stateAbbr',
  },
  {
    id: 'address',
    header: 'Address',
    accessorKey: 'address',
    size: 375,
  },
  {
    id: 'countyName',
    header: 'County Name',
    accessorKey: 'countyName',
  },
  {
    id: 'addrNumber',
    header: 'Site House Number',
    accessorKey: 'addrNumber',
  },
  {
    id: 'addrStreetName',
    header: 'Site Street Name',
    accessorKey: 'addrStreetName',
  },
  {
    id: 'addrStreetType',
    header: 'Site Street Type',
    accessorKey: 'addrStreetType',
  },
  {
    id: 'censusZip',
    header: 'Site Census ZIP Code',
    accessorKey: 'censusZip',
  },
  {
    id: 'mailName',
    header: 'Mailing Name',
    accessorKey: 'mailName',
  },
  {
    id: 'mailAddress1',
    header: 'Mailing Address Line 1',
    accessorKey: 'mailAddress1',
    size: 300,
  },
  {
    id: 'mailAddress3',
    header: 'Mailing Address 3',
    accessorKey: 'mailAddress3',
    size: 300,
  },
  {
    id: 'uspsResidential',
    header: 'USPS Residential',
    accessorKey: 'uspsResidential',
  },
  {
    id: 'countyId',
    header: 'County ID',
    accessorKey: 'countyId',
  },
  {
    id: 'mktValLand',
    header: 'Land Market Value',
    accessorKey: 'mktValLand',
  },
  {
    id: 'mktValBldg',
    header: 'Improvement Market Value',
    accessorKey: 'mktValBldg',
  },
  {
    id: 'bldgSqft',
    header: 'Building Area (sq. ft.)',
    accessorKey: 'bldgSqft',
  },
  {
    id: 'yearBuilt',
    header: 'Year Built',
    accessorKey: 'yearBuilt',
  },
  {
    id: 'landUseCode',
    header: 'Land Use Code',
    accessorKey: 'landUseCode',
    size: 250,
  },
  {
    id: 'landUseClass',
    header: 'Land Use Class',
    accessorKey: 'landUseClass',
  },
  {
    id: 'acreageCalc',
    header: 'Calculated Acreage',
    accessorKey: 'acreageCalc',
  },
  {
    id: 'latitude',
    header: 'Latitude',
    accessorKey: 'latitude',
  },
  {
    id: 'longitude',
    header: 'Longitude',
    accessorKey: 'longitude',
  },
  {
    id: 'elevation',
    header: 'Elevation (ft.)',
    accessorKey: 'elevation',
  },
  {
    id: 'robustId',
    header: 'Robust ID',
    accessorKey: 'robustId',
    size: 250,
  },
];
